import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SlideGame } from "@/components/game/SlideGame";
import { api, fmt, fmtDate } from "@/lib/api";

const BetsTable = ({ rows }) => (
  <div className="x-panel mt-6 overflow-x-auto">
    <div className="px-4 pt-4 pb-2 font-extrabold">Bahislerim</div>
    <table className="w-full text-sm" data-testid="my-bets-table">
      <thead>
        <tr className="text-[var(--x-muted)] text-left">
          <th className="px-4 py-2 font-semibold">Zaman</th>
          <th className="px-4 py-2 font-semibold text-right">Bahis</th>
          <th className="px-4 py-2 font-semibold text-right">Çarpan</th>
          <th className="px-4 py-2 font-semibold text-right">Ödeme</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((b, i) => (
          <tr key={b.id} className={i % 2 ? "" : "bg-[var(--x-bg-deep)]/50"}>
            <td className="px-4 py-2.5 text-[var(--x-muted)]">{fmtDate(b.created_at)}</td>
            <td className="px-4 py-2.5 text-right tabular-nums">₺{fmt(b.amount)}</td>
            <td className="px-4 py-2.5 text-right tabular-nums">{fmt(b.multiplier)}×</td>
            <td className={`px-4 py-2.5 text-right tabular-nums font-bold ${b.win ? "text-[var(--x-green)]" : "text-[var(--x-muted)]"}`}>
              {b.win ? `₺${fmt(b.payout)}` : `-₺${fmt(b.amount)}`}
            </td>
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={4} className="px-4 py-6 text-center text-[var(--x-dim)]">Henüz bahis yok</td></tr>
        )}
      </tbody>
    </table>
  </div>
);

export default function Game() {
  const { user, ready } = useAuth();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (user) api.get("/game/history").then((r) => setRows(r.data)).catch(() => {});
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (ready && !user) return <Navigate to="/" replace />;
  if (!user) return null;

  return (
    <div>
      <SlideGame onRound={(d) => setRows((r) => [d, ...r].slice(0, 20))} />
      <BetsTable rows={rows} />
    </div>
  );
}
